module.exports = {"632222100":"八宝镇","632222101":"峨堡镇","632222102":"默勒镇","632222200":"扎麻什乡","632222201":"阿柔乡","632222202":"野牛沟乡","632222203":"央隆乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/632222.json
// module id = 3133
// module chunks = 0